module.exports = __webpack_public_path__ + "img/effect_mode1.1.2d4c2f46.svg";